var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconButton } from "@material-ui/core";
import FTLIconButtonStyle from "../styles/FTLIconButtonStyle";
export default React.forwardRef((_a, ref) => {
    var { size, children, className = "", disableBackground, color = "secondary" } = _a, otherProps = __rest(_a, ["size", "children", "className", "disableBackground", "color"]);
    const classes = FTLIconButtonStyle({ size, disableBackground, color });
    return (React.createElement(IconButton, Object.assign({ ref: ref }, otherProps, { className: classes.root + " " + className }), children));
});
//# sourceMappingURL=FTLIconButton.js.map